import { routeList } from "routes/web"
import lodash from "lodash"
import deepdash from "deepdash"

export function findRoute(pathname) {
    const _ = deepdash(lodash)

    return _.findDeep(routeList, { path: pathname }, { childrenPath: 'children' })?.value
}